import { ReactElement, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import messages from '../../locales/messages';
import 'src/common/style/common.scss';
import { ThanksModal, thanksTable } from 'src/common/utils/ThanksModal';
import { object, pageTitle, pageUrl, productTitle } from '../../lib/tracker';

export interface thanksProps {
  employees: number;
  servers: number;
  lowerPrice: string;
  higherPrice: string;
  ndr: boolean;
  OnPrem: string;
  bpName: string;
}
const Thanks = ({
  employees,
  servers,
  lowerPrice,
  higherPrice,
  ndr,
  OnPrem,
  bpName,
}: thanksProps): ReactElement => {
  const intl = useIntl();
  const [showThanksModal, setShowThanksModal] = useState(true);
  const titleThanks: thanksTable[] = [
    { group: 'title', value: intl.formatMessage(messages['thankyou.title']) },
    {
      group: 'subTitle',
      value: intl.formatMessage(messages['thankyou.subtitle']),
    },
  ];
  const widgetTitleThanks: thanksTable[] = [
    {
      group: 'widgetTitle1',
      value: intl.formatMessage(messages['thankyou.details-title']),
    },
  ];
  const contentThanks: thanksTable[] = [
    {
      group: String(intl.formatMessage(messages['thankyou.details-employees'])),
      value: String(employees),
    },
    {
      group: String(intl.formatMessage(messages['labeltext_servers'])),
      value: String(servers),
    },
    {
      group: String(
        intl.formatMessage(messages['thankyou.details-monthly-cost']),
      ),
      value: `${lowerPrice} - ${higherPrice}`,
    },
    {
      group: String(intl.formatMessage(messages['thankyou.details-NDR'])),
      value: ndr
        ? intl.formatMessage(messages['yes'])
        : intl.formatMessage(messages['no']),
    },
    {
      group: String(intl.formatMessage(messages['thankyou.details-delivery'])),
      value: OnPrem,
    },
  ];
  bpName &&
    contentThanks.push({
      group: String(
        intl.formatMessage(messages['thankyou.details-selected-bp']),
      ),
      value: bpName,
    });
  bpName &&
    contentThanks.push({
      group: String(
        intl.formatMessage(messages['thankyou.details-consent-bp']),
      ),
      value: ndr
        ? String(intl.formatMessage(messages['yes']))
        : String(intl.formatMessage(messages['no'])),
    });
  const buttonThanks: thanksTable[] = [
    {
      group: 'button1',
      value: String(intl.formatMessage(messages['return-to-estimator'])),
    },
  ];
  const [showModal, setShowModal] = useState(false);
  useEffect(() => {
    setShowModal(true);
  }, [employees, servers]);
  return (
    <ThanksModal
      showThanksModal={showModal}
      pageTitle={pageTitle}
      object={object}
      productTitle={productTitle}
      pageUrl={pageUrl}
      location={'Estimator'}
      titleThanks={titleThanks}
      widgetTitleThanks={widgetTitleThanks}
      contentThanks={contentThanks}
      buttonThanks={buttonThanks}
      setShowThanksModal={setShowThanksModal}
    ></ThanksModal>
  );
};

export default Thanks;
